import * as _ from "lodash";
import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { OrganisationDataProvider } from "../../data-provider/organisation.dp";

let UpdateLeaderComponent = {
    selector: "vcUpdateLeader",
    templateUrl:
        "/angular/components/organisation/update-leader-dialog.component.html",
    bindings: {
        leader: "<",
    },
    controller: class UpdateLeaderController {
        // * bindings for typescript compiler *
        public leader: any;
        // ************************************

        private saving: boolean = false;
        private leaderCopy: object;

        private dialog: DialogUtils;
        private toast: ToastUtils;

        private organisationDataProvider: OrganisationDataProvider;

        constructor(DialogUtils, ToastUtils, OrganisationDataProvider) {
            this.dialog = DialogUtils;
            this.toast = ToastUtils;

            this.organisationDataProvider = OrganisationDataProvider;
        }

        $onInit(): void {
            this.leaderCopy = _.cloneDeep(this.leader);
        }

        cancel(): void {
            this.dialog.cancel();
        }

        updateLeader(leader): void {
            this.saving = true;
            this.organisationDataProvider.updateLeader(leader).then((json) => {
                this.saving = false;
                if (json.success) {
                    this.toast.success("Organization Name Updated");
                    this.dialog.hide(leader);
                } else {
                    this.toast.error();
                    this.dialog.cancel();
                }
            });
        }
    },
};

angular
    .module("organisation")
    .component(UpdateLeaderComponent.selector, UpdateLeaderComponent);
